export default defineNuxtPlugin(() => {
  // @INFO: Prevent Chrome Add to Home Screen / PWA install mini-infobar.
  // @vite-pwa installPrompt: false only hides vite-pwa's own UI.
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
  });
});
